import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles/utils/fill";
export const SeiLogo = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      fill: t1,
      fillAttribute: t2,
      size: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const fill = t1 === undefined ? "current" : t1;
  const fillAttribute = t2 === undefined ? "currentColor" : t2;
  const size = t3 === undefined ? 24 : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M11.97 24c3.564 0 6.767-1.547 8.97-4.004a2.859 2.859 0 0 0-3.66-.064l-.208.168a4.825 4.825 0 0 1-6.618-.54 2.575 2.575 0 0 0-3.591-.24L4.46 21.377A11.999 11.999 0 0 0 11.97 24Zm3.9-5.81a5.11 5.11 0 0 1 6.407.002A11.921 11.921 0 0 0 24 12c0-2.517-.777-4.853-2.105-6.783a2.854 2.854 0 0 0-2.488.653l-.2.177a4.825 4.825 0 0 1-6.636-.234 2.576 2.576 0 0 0-3.598-.074L6.176 8.363l-1.538-1.63 2.796-2.625a4.825 4.825 0 0 1 6.741.138 2.576 2.576 0 0 0 3.543.125l.2-.177a5.08 5.08 0 0 1 2.097-1.116A12.003 12.003 0 0 0 11.969 0C5.862 0 .818 4.54.042 10.42a4.938 4.938 0 0 1 5.656.998 2.686 2.686 0 0 0 3.57.24l1.563-1.22a5.215 5.215 0 0 1 6.623.178l3.044 2.645-1.475 1.688-3.044-2.645a2.965 2.965 0 0 0-3.766-.1l-1.564 1.218a4.936 4.936 0 0 1-6.557-.44 2.686 2.686 0 0 0-3.754-.081L0 13.218a11.934 11.934 0 0 0 2.838 6.595L5.4 17.62a4.825 4.825 0 0 1 6.728.448 2.576 2.576 0 0 0 3.533.288l.208-.168Z" fill={fillAttribute} />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};